// extracted by mini-css-extract-plugin
export default {"title":"_8649623af0","bld":"_02e4626f76"};